module.exports = __webpack_public_path__ + "img/maintenance.6382352a.png";